import React, { useContext, useState, useMemo } from 'react'
import './index.scss'
import { RESOURCE_MANAGER } from '@/config'
import { AvatarContext } from '@/components/RenderComp/Avatar'

const AvatarSelect = (props) => {
    const { scheduleUpdateAvatar, avatarConfig } = useContext(AvatarContext)
    const { style } = props
    const handleSelectAvatar = async (gender) => {
        const list = [
            ...RESOURCE_MANAGER.defaultAvatarList,
            ...JSON.parse(window.localStorage.getItem('avatarList') || '[]')
        ]
        const config = list.reverse().find(avatar => avatar.data.gender === gender)
        console.log('config', config)
        await scheduleUpdateAvatar(config)
    }
    const gender = useMemo(() => {
        return avatarConfig?.data.gender
    }, [avatarConfig])
    return (
        <div
            className="avatar-manager"
            style={style}
        >
            <img
                onClick={() => { handleSelectAvatar('female') }}
                src={
                    gender === 'male'
                        ? require('@/assets/slices/icon_female_nor.png')
                        : require('@/assets/slices/icon_female_sel.png')
                }
                alt=""
            />
            <img
                onClick={() => { handleSelectAvatar('male') }}
                src={
                    gender === 'male'
                        ? require('@/assets/slices/icon_male_sel.png')
                        : require('@/assets/slices/icon_male_nor.png')
                }
                alt=""
            />
        </div>
    )
}

export default AvatarSelect
